export const strings = {
    prefixAgo: 'hashize',
    prefixFromNow: 'mu',
    suffixAgo: null,
    suffixFromNow: null,
    seconds: 'amasegonda macye',
    minute: 'umunota',
    minutes: 'iminota %d',
    hour: 'isaha',
    hours: 'amasaha %d',
    day: 'umunsi',
    days: 'iminsi %d',
    month: 'ukwezi',
    months: 'amezi %d',
    year: 'umwaka',
    years: 'imyaka %d',
    wordSeparator: ' ',
};
